import { activityCustomTypesAccessLevels } from "PFCore/helpers/custom_types";
import { getVisibleProperties } from "PFCore/helpers/templates";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { AccessLevel, Activity, Engagement, Role, Template } from "PFTypes";
import { useMemo } from "react";

const PRIORITY = "priority";

export const usePriorityVisibility = (activity: Activity | Role | Engagement, template?: Template) => {
  const { data: currentProfile } = useCurrentProfile();
  const { customTypes } = useCustomTypes();

  return useMemo(() => {
    // TODO: [SP-6880] Fix `any` type. Add `subtemplate_key` to Engagement type
    const subtemplate = (activity as any).subtemplate_key
      ? template?.schema.subtemplates?.[(activity as any).subtemplate_key]
      : null;

    const isPriorityInTemplate = !!getVisibleProperties(template).find(({ name }) => name === PRIORITY);
    const isPriorityInSubtemplate = !!subtemplate?.properties.priority;
    const priorityCustomType = customTypes.find((type) => type.name === PRIORITY);

    const accessLevel =
      !!priorityCustomType &&
      activityCustomTypesAccessLevels(currentProfile, activity.profile)[priorityCustomType.id];

    const isPriorityAvailable =
      isPriorityInTemplate &&
      (!subtemplate || isPriorityInSubtemplate) &&
      !!priorityCustomType &&
      !!accessLevel;

    const isPriorityDisabled = accessLevel !== AccessLevel.ReadWrite;
    const isPriorityRequired = (subtemplate ?? template?.schema)?.required.includes(PRIORITY);

    return { isPriorityAvailable, isPriorityDisabled, isPriorityRequired };
  }, [(activity as any).subtemplate_key, activity.profile, customTypes, currentProfile]);
};
